module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Fc-Ga-Hc-Ic-Jb.b549adf2.png";